import api from '../../utils/api';

export const removeKeyPlan = (id: number) =>
  api.delete({
    url: `/property/keyplan/${id}`,
  });
